@if (wrapper()) {
  <div class="table-container mt-4">
    <p-card>
      <ng-container *ngTemplateOutlet="tableContent" />
    </p-card>
  </div>
} @else {
  <ng-container *ngTemplateOutlet="tableContent" />
}

<ng-template #tableContent>
  <p-table
    [columns]="displayedColumns()"
    [scrollable]="isScrollable()"
    [value]="tableDataSource()"
    [sortMode]="'single'"
    [customSort]="true"
    [sortField]="sortField()"
    [sortOrder]="sortOrder()"
    (sortFunction)="onSort($event)"
  >
    <!-- HEADERS -->
    <ng-template #header let-columns>
      <tr>
        @for (action of displayedActions(); track action) {
          <th class="row-actions" pFrozenColumn [frozen]="action.sticky">{{action.label | translate}}</th>
        }
        @for (column of displayedColumns(); track column.name) {
          <th [ngClass]="{'right-border': column.rightBorder}"
            [pSortableColumn]="column.sortable ? column.name : undefined"
            [pSortableColumnDisabled]="!column.sortable"
          >
            <div class="flex items-center gap-2">
              {{column.label | translate}}
              @if (column.sortable) {
                <p-sortIcon [field]="column.name" />
              }
            </div>
          </th>
        }
      </tr>
    </ng-template>
    <!-- BODY -->
    @if (tableDataSource().length > 0) {
      <ng-template #body let-rowData let-columns="columns">
        <tr [ngClass]="{'linked': isLinked()}" (click)="onRowClick(rowData)">
          @for (action of displayedActions(); track action) {
            <td pFrozenColumn [frozen]="action.sticky" (click)="$event.stopPropagation();">
              <button pButton [outlined]="true" (click)="emitRowAction(action.name, rowData)">
                <i [class]="'fa-solid fa-' + action.icon"></i>
              </button>
            </td>
          }
          @for (col of displayedColumns(); track col) {
            <td>
              @if (col.type == 'icon') {
                <i [style.color]="getIconColor(rowData, col)" [class]="getIcon(rowData, col)"></i>
              } @else if (col.type == 'liveness') {
                <cosmos-measurement-liveness-badge
                  [measurementType]="rowData.measurementType"
                  [lastTimestamp]="getLivenessLastTimestamp(rowData)"
                ></cosmos-measurement-liveness-badge>
              } @else if (col.tag == true) {
                <p-tag [value]="getTagLabel(rowData, col)" [severity]="getTagSeverity(rowData, col)" />
              } @else {
                {{ findColumnValue(rowData, col) }}
              }
            </td>
          }
        </tr>
      </ng-template>
    } @else {
      <ng-template #emptymessage>
        <tr>
          <td [attr.colspan]="displayedColumns().length + displayedActions().length">{{ 'table.no-data' | translate }}</td>
        </tr>
      </ng-template>
    }
  </p-table>
  @if (isPageable()) {
    <p-paginator
      (onPageChange)="onPageChange($event)"
      [showCurrentPageReport]="true"
      currentPageReportTemplate="{first}-{last} / {totalRecords}"
      [pageLinkSize]="3"
      [first]="currentFirst()"
      [rows]="currentPageSize()"
      [totalRecords]="totalRecords()"
      [rowsPerPageOptions]="paginationSizes()"
    />
  }
</ng-template>
